    if (!customElements.get('product-form')) {
                      customElements.define(
                        'product-form',
                        class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          return;
        }
        
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        
        if (!this.submitButton) {
          return;
        }
        
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        try {
          evt.preventDefault();
          
          if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') {
            return;
          }

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          
          if (this.submitButton.classList) {
            this.submitButton.classList.add('loading');
          }
          
          const spinner = this.querySelector('.loading__spinner');
          if (spinner && spinner.classList) {
            spinner.classList.remove('hidden');
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

                                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                                if (!this.error)
                                  publish(PUB_SUB_EVENTS.cartUpdate, {
                                    source: 'product-form',
                                    productVariantId: formData.get('id'),
                                    cartData: response,
                                  }).then(() => {
                                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                                  });
                                this.error = false;
                                const quickAddModal = this.closest('quick-add-modal');
                                if (quickAddModal) {
                                  document.body.addEventListener(
                                    'modalClosed',
                                    () => {
                                      setTimeout(() => {
                                        CartPerformance.measure("add:paint-updated-sections", () => {
                                          this.cart.renderContents(response);
                                        });
                                      });
                                    },
                                    { once: true }
                                  );
                                  quickAddModal.hide(true);
                } else {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                }
                              })
          .catch((e) => {
            const errorMsg = e.message || window.cartStrings?.error || 'An error occurred. Please try again.';
            this.handleErrorMessage(errorMsg);
            
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            if (errors) {
              errors.textContent = errorMsg;
            }
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
            
            if (this.cart && this.cart.classList && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
        } catch (error) {
          this.handleErrorMessage('An unexpected error occurred. Please refresh the page and try again.');
        }
      }

                          handleErrorMessage(errorMessage = false) {
                            if (this.hideErrors) return;

                            this.errorMessageWrapper =
                              this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                            if (!this.errorMessageWrapper) return;
                            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                            if (errorMessage) {
                              this.errorMessage.textContent = errorMessage;
                            }
                          }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

                          get variantIdInput() {
                            return this.form.querySelector('[name=id]');
                          }
                        }
                      );
                    }
 